
		/*![Panoramic photo of the entire Google Glass team](/blog-images/glass-pano.jpg)*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "dreamland/jsx-runtime";
import {PhotoSphere} from "../components/PhotoSphere";
export const title = "Google Glass was ahead of it's time, actually";
export const description = "Some thoughts on a device that came out too soon.";
export const tags = ["Review", "Retrospective", "Opinion"];
export const image = "/blog-images/glass-pano.jpg";
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    code: "code",
    img: "img",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: ["\n", _jsx(PhotoSphere, {
      src: "/blog-images/glass_team_sphere_raw.jpg",
      fallback: "/blog-images/glass-pano.jpg",
      autorotateConfig: {
        autorotateSpeed: "0.3rpm",
        autostartDelay: 0,
        autostartOnIdle: false
      }
    }), "\n", _jsxs("cap", {
      children: [_jsxs("subt", {
        children: [_jsx("span", {
          class: "material-symbols",
          children: "info"
        }), "The team behind Google Glass."]
      }), _jsx("br", {}), _jsxs("subt", {
        children: ["Image credit: Google. Extracted from the Glass OS ", _jsx(_components.a, {
          href: "https://www.youtube.com/watch?v=ndFySj-wrGw",
          children: "easter egg."
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "I recently bought a sealed pair of Google Glass from eBay. They've been slowly entering the used market as people start clearing out old drawers, and they can often be found for around 100 dollars (a far cry from their MSRP of $1500). I managed to snag my pair from a seller who seemed to be selling a couple hundred units that were supposed to be corporate gifts."
    }), "\n", _jsx(_components.p, {
      children: "We'll probably never know who was supposed to get these since the seller tried to redact the barcode and other info on the shrink wrap, but after some shipping delays, it arrived in one piece. My unit was the XE-C, which meant it had 2GB of RAM instead of the 1GB in earlier models. All Explorer Edition models also shipped with 16GB of onboard storage and were powered by the Texas Instruments OMAP 4430, a dual-core ARM processor clocked at 1.2 GHz."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/glass-teardown-exploded-top.jpg",
        alt: "Google Glass, Exploded view"
      })
    }), "\n", _jsxs("cap", {
      children: [_jsxs("subt", {
        children: [_jsx("span", {
          class: "material-symbols",
          children: "info"
        }), "Image credit: Scott Torborg and Star Simpson."]
      }), _jsx("br", {}), _jsxs("subt", {
        children: ["Licenced under CC BY-NC-SA 3.0 ", _jsx(_components.a, {
          href: "http://www.catwig.com/google-glass-teardown/",
          children: "Source"
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "It's really impressive how in 2012 they were able to fit that much compute into a segment about as big as my index finger. Admittedly, that's not a great point of reference, as I have rather small hands."
    }), "\n", _jsxs(_components.p, {
      children: ["Booting it for the first time, I was immediately met with a setup screen that I couldn't progress through due to the Glass-specific authentication servers being shut down years ago. Fortunately, before the servers were shut down, Google released ", _jsx(_components.a, {
        href: "https://support.google.com/glass/answer/9649198",
        children: "one final software update"
      }), " which removed the reliance on those servers, which I installed via ", _jsx(_components.code, {
        children: "fastboot"
      }), ". I never thought I'd say this, but more companies should take notes from Google on how to properly discontinue a product."]
    }), "\n", _jsx(_components.p, {
      children: "Surprisingly, there's still a small, albeit passionate group of Glass enthusiasts doing new things with the device. I was able to find some useful apps, such as a YouTube client, an OpenStreetMap-based maps app, a replacement for the now-dead mobile companion app, and a game or two."
    }), "\n", _jsxs(_components.p, {
      children: ["With a bit of help from the community, I was also able to bootstrap creating my own Glassware (yes, that's the actual name, truly amazing stuff) using the latest version of Android Studio. At the time of writing, I've been creating ", _jsx(_components.a, {
        href: "http://glasstodon.bomberfish.ca/?ref=blog",
        children: "a Mastodon client for Glass"
      }), "."]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "By the way, while I was building that client, I've been testing a new approach to using LLMs in programming. I might write a separate blog post about that approach and how I've been applying it, so stay tuned."
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Anyway, after Glass Explorer Edition flopped and got discontinued in 2015, Google ended up bringing the team (shown at the top of this post) back together to create a couple of follow-ups meant for enterprise customers."
    }), "\n", _jsx(_components.p, {
      children: "The first Enterprise Edition device, released in 2017, is widely regarded as what the Explorer Edition should have been, with various spec bumps across the board. What's really interesting about the EE1 is that it used an Intel Atom CPU, which, as an x86 design, was an odd choice for the form factor."
    }), "\n", _jsx(_components.p, {
      children: "They followed up with the Enterprise Edition 2 in 2019, which brought more substantial upgrades to components such as the camera and microphones, and a more reasonable processor: the Qualcomm Snapdragon XR1 SoC. Support for both EE1 and EE2 was discontinued in 2023, marking the end of the line for Glass."
    }), "\n", _jsx(_components.p, {
      children: "The Enterprise Edition models usually fetch much higher prices second hand, which is why I got an Explorer Edition instead. Maybe I'll get an EE2 eventually if I can find use cases for my XE."
    }), "\n", _jsxs(_components.p, {
      children: ["It's a real shame how the platform failed, but it did make sense. The form factor was odd, made you ", _jsx(_components.a, {
        href: "https://www.youtube.com/watch?v=2Tvy_Pbe5NA&t=121s",
        children: "look like a dweeb"
      }), ", and worst of all, it couldn't even tell you someone's ", _jsx(_components.a, {
        href: "https://www.youtube.com/watch?v=SiMHTK15Pik&t=8",
        children: "power level!"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["That being said, recent developments in AR display tech, namely waveguide displays, might bring back the notion of AR wearables. You can already buy the ", _jsx(_components.a, {
        href: "https://www.meta.com/ca/ai-glasses/meta-ray-ban-display/",
        children: "Meta Ray-Ban Display Glasses"
      }), ", and ", _jsx(_components.a, {
        href: "https://www.androidauthority.com/glasses-companion-app-3631808/",
        children: "signs"
      }), " point to more similar devices coming out this year."]
    }), "\n", _jsxs(_components.p, {
      children: ["Unfortunately for the hopes of widespread adoption, most companies are branding them as \"AI Glasses\" (which is definitely going to leave a bad taste in people's mouths), and there have already been ", _jsx(_components.a, {
        href: "https://www.wired.com/story/the-rise-of-the-ray-ban-meta-creep/",
        children: "various"
      }), " ", _jsx(_components.a, {
        href: "https://9to5mac.com/2026/03/03/meta-ray-ban-smart-glasses-send-sensitive-videos-to-human-data-annotators/",
        children: "scandals"
      }), " regarding the cameras in these devices."]
    }), "\n", _jsx(_components.p, {
      children: "Maybe I'll revisit this when something happens."
    })]
  });
}
export function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}


		export default function Page() {
			const {wrapper: MDXLayout} = this.components || ({});
			return (
				MDXLayout 
					? _jsx(MDXLayout, { children: [_createMdxContent(this)], ...this })
					: _createMdxContent(this)
			)
		}
	